export const blockIconsPrivacyandsecurityRemoveModeratorNew = (
	<span className='material-symbols-outlined'>remove_moderator</span>
);
